import React, {useEffect, useState} from 'react';
import VerticalSlider from "../SlotMachines/VerticalSlider";
import parse from "html-react-parser";
import HorizontalSlider from "../SlotMachines/HorizontalSlider";
import {useFetching} from "../../hooks/useFetching";
import {API_LOTTERY_FIRST_SECTION} from "../../utils/consts";
import {useLocation} from "react-router-dom";
import ApiLotteryFirstSection from "../../services/Lottery/FirstSection";
import Loader from "../Loader";

// import hor1 from "../../img/sliders/mmg-6/01.jpg";
// import hor2 from "../../img/sliders/mmg-6/02.jpg";
// import hor3 from "../../img/sliders/mmg-6/03.jpg";
// import hor4 from "../../img/sliders/mmg-6/04.jpg";
// import hor5 from "../../img/sliders/mmg-6/05.jpg";
// import hor6 from "../../img/sliders/mmg-6/06.jpg";
// import hor7 from "../../img/sliders/mmg-6/07.jpg";
// import lot1 from "../../img/lottery/1.gif";
// import lot2 from "../../img/lottery/2.gif";

const FirstSection = () => {
    const location = useLocation()

    const [item, setItem] = useState()
    // const [item, setItem] = useState({name: 'Лотерейне програмне забезпечення', content: '<p>Наші розробники створили електронну систему лотереї, яка відповідає всім сучасним вимогам і може бути адаптована відповідно до законодавства конкретної країни. Наші системи онлайн-лотереї забезпечують автоматичну прегенерацію квитків, надійну роботу системи, прозору систему звітів, а також інтеграцію з сервісами третіх сторін.</p> <ul> <li>Робота в режимі короткого або довгого квитків.</li> <li>Використання RFID карти або термінального чека.</li> <li>Задання точного відсотка призового фонду при генерації серії квитків.</li> <li>Автоматичне відрахування податку з виграшу гравця.</li> </ul>', ver_gallery: [lot1, lot2], hor_gallery: [{prev_image: hor1, orig_image: hor1}, {prev_image: hor2, orig_image: hor2}, {prev_image: hor3, orig_image: hor3}, {prev_image: hor4, orig_image: hor4}, {prev_image: hor5, orig_image: hor5}, {prev_image: hor6, orig_image: hor6}, {prev_image: hor7, orig_image: hor7}]})
    const [loading, setLoading] = useState(true)

    const [FunctionApiLotteryFirstSection] = useFetching(async () => {
        try {
            const response = await ApiLotteryFirstSection.getApiLotteryFirstSection(API_LOTTERY_FIRST_SECTION);
            setItem(response.data);
        } catch {
            console.error('FunctionApiLotteryFirstSection')
        }
    });

    useEffect(() => {
        FunctionApiLotteryFirstSection();
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {(!item && loading) && <Loader />}
            {item && <div className="first_row">
                <div className="row">
                    <div className="sliders">
                        <div className='items'>
                            {window.innerWidth <= 1366 ? item.name ? <h1>{item.name}</h1> : null : null}
                            {item.ver_gallery ? <div className="block_left">
                                <VerticalSlider gallery={item.ver_gallery} loading={loading} setLoading={setLoading} />
                            </div> : null}
                            <div className="block_right">
                                {window.innerWidth > 1366 ? item.name ? <h1>{item.name}</h1> : null : null}
                                {item.content ? <div className="list characteristics">
                                    {parse(item.content)}
                                </div> : null}
                                {item.hor_gallery && item.hor_gallery.length ? <div className="list photo">
                                    <HorizontalSlider gallery={item.hor_gallery} />
                                </div> : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
};

export default FirstSection;